// Real content for Sano Acupuncture site (sourced from sanoacu.com)

export const BOOKING_URL = "https://joannie-campuzano-cepeda.clientsecure.me";
export const GOOGLE_REVIEW_URL = "https://g.page/r/Cesfk43U40Z9EBM/review";
export const FREE_GUIDE_URL = "/assets/sano-free-guide.pdf";
export const INSTAGRAM_URL = "https://instagram.com/sanoacupuncture";
export const PHONE = "929.272.6066";
export const PHONE_TEL = "tel:9292726066";
export const EMAIL = "sanoacu@gmail.com";
export const ADDRESS_LINE_1 = "952 Southern Blvd #202";
export const ADDRESS_LINE_2 = "Bronx, NY 10459";

// Joannie's real photos hosted by SimplePractice / CloudFront
export const PRACTITIONER_PHOTO = "/assets/joannie-portrait.jpg";
export const HERO_PHOTO = "/assets/sano-logo.jpg";

export const SERVICES = [
  {
    id: "acupuncture",
    title: "Acupuncture",
    duration: "60 min",
    price: "$70 – $300",
    blurb:
      "Classical needling along meridian pathways to address anxiety, depression, trauma, muscle tension, joint pain, PMS, menstrual concerns, and headaches.",
    image:
      "https://images.unsplash.com/photo-1620733723572-11c53f73a416?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "cupping",
    title: "Cupping Therapy",
    duration: "45 min",
    price: "$60",
    blurb:
      "Glass-cup suction along the back, shoulders, and legs to release fascia, clear stagnation, and soften stubborn pain — a two-thousand-year-old conversation with the muscle.",
    image:
      "https://images.unsplash.com/photo-1745327883389-17150e99dcf7?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "ear-seeds",
    title: "Ear Seeds",
    duration: "20 min",
    price: "$20",
    blurb:
      "Tiny gold or vaccaria seeds placed on auricular acupressure points — for stress, sleep, cravings, anxiety or focus. They keep working on you for 3–5 days after the visit. A perfect add-on or quick reset on its own.",
    image:
      "https://images.unsplash.com/photo-1632568851266-b8e23c1738f5?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "facial-acupuncture",
    title: "Facial Acupuncture",
    duration: "60 min",
    price: "$70 – $300",
    blurb:
      "A gentle, certified protocol that boosts circulation, encourages collagen response and restores a softer, more rested face — inside and out.",
    image:
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "yoni-steam",
    title: "Yoni Herbal Steam",
    duration: "30 min",
    price: "$60 – $80",
    blurb:
      "A grounding, ceremonial herbal steam for menstrual care, postpartum recovery, and reconnection with the body in a calm, private space.",
    image:
      "https://images.unsplash.com/photo-1509156396595-449e10c5cd3e?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
  {
    id: "nervous-system",
    title: "Nervous System Reset",
    duration: "75 min",
    price: "from $150",
    blurb:
      "A signature blend of acupuncture, breath and intentional rest designed to bring the body out of stress response and back into safety.",
    image:
      "https://images.unsplash.com/photo-1545205597-3d9d02c29597?fm=jpg&q=80&w=1200&auto=format&fit=crop",
  },
];

export const APPROACH_PILLARS = [
  {
    n: "01",
    title: "Listen to the Body",
    text:
      "Pulse, tongue, posture, breath. We read the body as a living text — not a list of symptoms to fix.",
  },
  {
    n: "02",
    title: "Regulate the Nervous System",
    text:
      "Before anything heals, the system needs to feel safe. Gentle, repeatable, evidence-informed care.",
  },
  {
    n: "03",
    title: "Eastern Medicine, Whole-Body Care",
    text:
      "Acupuncture, cupping, facial work, herbal steam — Traditional Chinese Medicine adapted for modern New York life.",
  },
  {
    n: "04",
    title: "Release What No Longer Serves",
    text:
      "Make space for clarity and alignment. Healing isn't only what arrives — it's also what is allowed to leave.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Joannie creates such a calming and healing experience from start to finish. Her treatments helped me reduce stress and feel more balanced. I highly recommend her.",
    name: "Kelly",
    role: "Client",
  },
  {
    quote:
      "I have been coming in for acupuncture and cupping for my back, and it has been an amazing experience. I love the sessions and my back pain is gone.",
    name: "Maria",
    role: "Client",
  },
  {
    quote:
      "A calm, supportive environment where I could finally exhale. I left feeling lighter, more grounded — like myself again.",
    name: "Sano Client",
    role: "Bronx, NY",
  },
];

export const BLOG_POSTS = [
  {
    slug: "what-is-nervous-system-reset",
    title: "What is a Nervous System Reset?",
    date: "Nov 12, 2025",
    minutes: 6,
    excerpt:
      "A plain-language tour of why your body forgets how to rest, and the points and rituals that bring it back.",
    cover:
      "https://images.unsplash.com/photo-1493898719456-b0e84bba5fcc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjYWxtJTIwbmF0dXJlJTIwbWluaW1hbGlzdHxlbnwwfHx8fDE3ODIxNjQ3MTd8MA&ixlib=rb-4.1.0&q=85",
    body: [
      "Your nervous system has two main settings — fight-or-flight (sympathetic) and rest-and-digest (parasympathetic). In a healthy day, you flow between them dozens of times. Wake up, get the kids ready, push through email, drop into lunch, push again, come home, soften. But for most of us in this city — Black and brown women especially — the soft setting has gone quiet. The body forgets how to come down.",
      "A nervous system reset is exactly what it sounds like: a deliberate practice of teaching your body, again and again, that it is safe to drop into rest. Not exhaustion. Not collapse. Rest — the kind where the breath slows on its own, the jaw releases, and you suddenly notice you're hungry.",
      "In the treatment room I use acupuncture, breath cues, gentle ear seeds, and sometimes nothing more than a warm room and 45 minutes of permission. At home you can do a smaller version every day: feet on the floor, four slow exhales twice as long as your inhales, one hand on your sternum. Three minutes. That's it.",
      "When clients ask me what they should expect from a Nervous System Reset session at Sano, I tell them: nothing dramatic. You will lie down. The needles will be thinner than a strand of hair. You will probably fall asleep. And the next morning, the small thing that has been driving you all week — the clenched shoulder, the 3 a.m. wake-up, the sigh you can't seem to take — will be a little quieter.",
      "Healing isn't loud. It's a body remembering its own rhythm.",
    ],
  },
  {
    slug: "five-elements-101",
    title: "Five Elements 101: Reading Your Body's Weather",
    date: "Oct 28, 2025",
    minutes: 8,
    excerpt:
      "Wood, Fire, Earth, Metal, Water — how your constitution shapes the foods, herbs and seasons that nourish you.",
    cover:
      "https://images.pexels.com/photos/29387145/pexels-photo-29387145.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Classical Chinese medicine looks at the body the way a gardener looks at soil — what's growing well, what's wilting, what needs more sun, what needs to be cut back. The Five Elements (Wood, Fire, Earth, Metal, Water) are five different soils. We all carry all five, but one or two run the show.",
      "Wood is the green of spring — drive, vision, the urge to plan and push forward. When Wood is balanced, you get things done. When Wood is stuck, you get headaches behind the eyes, irritability, tight ribs, a clenched jaw, PMS that feels like a thunderstorm.",
      "Fire is the heart and the spark — joy, connection, the warmth you feel in good company. Balanced Fire laughs easily. Out-of-balance Fire is insomnia, racing thoughts, restlessness, and that strange loneliness you feel in a crowded room.",
      "Earth is the late-summer harvest — your stomach, your nourishment, your sense of being held. Balanced Earth feeds itself and others. Wobbly Earth shows up as worry that won't stop, sweet cravings, bloating, fatigue after eating.",
      "Metal is autumn — the cool, clear breath, the ability to let go. Balanced Metal grieves clean and moves on. Out-of-balance Metal is shallow breath, recurring colds, grief that lingers too long, and skin that feels dry no matter what you put on it.",
      "Water is winter — the deep reserves, the kidneys, the bones, the will. Balanced Water has stamina. Depleted Water is burnout, low back pain, fear that won't name itself, hair thinning, hearing that feels distant.",
      "Which one is loudest in you right now? That's your weather today. We'll work with it, not against it. (Take the 5-element quiz on the site if you want a starting place — it takes about 90 seconds and it's surprisingly accurate.)",
    ],
  },
  {
    slug: "cupping-explained",
    title: "Cupping, Explained Gently",
    date: "Oct 10, 2025",
    minutes: 4,
    excerpt:
      "What those circles really are, why they fade, and how the practice has been quietly helping bodies for two thousand years.",
    cover:
      "https://images.pexels.com/photos/34468521/pexels-photo-34468521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: [
      "Cupping looks dramatic — the round marks on athletes' shoulders, the dark purple rings — but the practice itself is one of the gentlest things I do. A glass or silicone cup, a quick suction, and the cup rests on the back, the shoulders, the calves. Anywhere muscle has been guarding for a long time.",
      "What's actually happening underneath: the suction lifts the fascia (the connective tissue that wraps every muscle) away from the muscle. That tiny lift draws fresh blood to the area, breaks up the stuck microcirculation, and tells the muscle it's allowed to soften. The marks you see afterward are not bruises — they're stagnant blood and fluid that the body finally pulled to the surface to clear out. They fade in three to seven days, lighter each time you come.",
      "I use cupping most often for chronic back and shoulder tension, post-workout recovery, and the long-held holding that comes from caregiving — physical and emotional. It pairs beautifully with acupuncture; many of my sessions blend the two.",
      "It is not a one-off miracle. It is a conversation the body has with itself, and it gets clearer with repetition. Most people start to feel a real shift after the second or third session.",
      "If you've never tried it and you're curious, book a 60-minute session and we'll start with a few cups in the most-locked area. You'll know within ten minutes if your body likes it. (It almost always does.)",
    ],
  },
];

export const EVENTS = [
  {
    title: "Winter Nervous System Reset Circle",
    date: "Dec 14, 2025",
    time: "6:30 – 8:00 pm",
    location: "Sano Studio, Bronx",
    blurb: "Group acupuncture, breathwork and warming herbal tea. Limited to 8 seats.",
  },
  {
    title: "Yoni Steam Ritual Workshop",
    date: "Jan 11, 2026",
    time: "11:00 am – 1:30 pm",
    location: "Sano Studio, Bronx",
    blurb:
      "Learn the tradition, herbs and contraindications of yoni steaming, plus your own at-home blend to take home.",
  },
  {
    title: "Lunar New Year Community Reset",
    date: "Feb 7, 2026",
    time: "10:00 am – 12:00 pm",
    location: "Sano Studio, Bronx",
    blurb: "Welcome the new year with seated acupuncture, ritual, and intention setting.",
  },
];

export const FUN_FACTS = [
  "The classical acupuncture text Huangdi Neijing dates back over 2,000 years.",
  "There are 361 classical acupuncture points along 14 meridians.",
  "In Chinese Medicine, the kidneys store 'jing' — the body's deepest reserve battery.",
  "Stress patterns are described as 'Liver Qi stagnation' — when the river of energy stops flowing.",
  "Spring belongs to Wood, summer to Fire, late summer to Earth, autumn to Metal, winter to Water.",
  "Sticking out your tongue is part of every TCM intake — its colour, shape and coating tell a story.",
];

export const INSURANCE = [
  "1199 SEIU National Benefit Fund",
  "Aetna",
  "Anthem",
  "Blue Cross Blue Shield",
  "SEIU",
  "United Healthcare",
];

export const PRACTITIONER = {
  name: "Joannie Campuzano Cepeda",
  title: "Licensed Acupuncturist · Founder of Sano Acupuncture",
  oneLiner:
    "Over 10 years of experience. Specializing in pain relief and nervous system regulation through acupuncture, cupping, facial acupuncture and yoni herbal steam.",
  bio: [
    "Welcome — I created Sano as a space for healing, restoration and reconnection. With over ten years of experience as a licensed acupuncturist, my approach combines holistic healing, nervous system care, and personalized wellness treatments designed to help clients feel more balanced, grounded, and supported in both body and mind.",
    "I specialize in pain relief and nervous system regulation, helping clients work with stress, tension, burnout, emotional overwhelm and physical discomfort through acupuncture, cupping therapy and restorative wellness rituals. I am also certified in facial acupuncture and yoni steam therapy, offering treatments that support physical healing alongside overall well-being and rejuvenation.",
    "My goal is to create a calming, supportive environment where you can slow down, reconnect with yourself, and experience healing in an intentional, restorative way. The body has an incredible ability to heal when it feels safe, cared for, and brought back into balance.",
  ],
};
